var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#abb3ba",
  d: "M14.576 13.548h-.542l-.192-.186a4.44 4.44 0 0 0 1.077-2.902 4.46 4.46 0 1 0-4.46 4.46 4.44 4.44 0 0 0 2.903-1.077l.185.192v.542L16.977 18 18 16.979zm-4.116 0c-1.709 0-3.088-1.38-3.088-3.088s1.38-3.087 3.088-3.087 3.087 1.379 3.087 3.087-1.379 3.088-3.087 3.088"
})));
export default SvgSearch;